import { render, staticRenderFns } from "./InvestorFunnel.vue?vue&type=template&id=bffe2726&"
import script from "./InvestorFunnel.vue?vue&type=script&lang=js&"
export * from "./InvestorFunnel.vue?vue&type=script&lang=js&"
import style0 from "./InvestorFunnel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports